import { Table } from '@/components/document_type/table'

export const DocumentTypes = () => {
  return (
    <>
      <Table pageSize={20} createable onIndex />
    </>
  )
}
